export const availableDimensions = [
  { width: 300, height: 250 },
  { width: 970, height: 250 },
  { width: 250, height: 250 },
  { width: 728, height: 90 },
  { width: 320, height: 50 },
  { width: 320, height: 100 }
]
